module.exports = __webpack_public_path__ + "static/media/video-5-1.80936875.mp4";